import { spevalApi } from 'yxt-biz-pc/packages/api';

spevalApi.defaults.headers['x-yxt-product'] = 'sp';

export const addEvalUserRelation = (evaluationId, data) => { // 评估关系增加评估人
  return spevalApi.post(`/mgr/evaluationusers/${evaluationId}/addEvalUserRelation`, data);
};

export const deleteEvalRelationUsers = (evaluationId, data) => { // 评估关系删除评估人
  return spevalApi.post(`/mgr/evaluationusers/${evaluationId}/deleteEvalRelationUsers`, data);
};

export const addEvalUserRelationDynamic = (evaluationId, data) => { // 评估关系增加评估人
  return spevalApi.post(`/mgr/formusers/${evaluationId}/addEvalUserRelation`, data);
};

export const deleteEvalRelationUsersDynamic = (evaluationId, data) => { // 评估关系删除评估人
  return spevalApi.post(`/mgr/formusers/${evaluationId}/deleteEvalRelationUsers`, data);
};
